module.exports = __webpack_public_path__ + "static/assets/c9eb9a25b468d850aef34ad1bcf04d8f.png";